import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../pages/authentication/Login'
import ForgotPassword from '../pages/authentication/ForgotPassword';
import SetPassword from '../pages/authentication/SetPassword';
import Layout from '../shared/Layout'
import ApproveTimesheetExpense from '../pages/approval/ApproveTimesheetExpense';

const LayoutNavigation = (props) => {
    return (
        <Router>
            <React.Suspense fallback={null}>
                <Routes>
                    <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                    {
                        (window.location.pathname.toLocaleLowerCase() !== "/login" && window.location.pathname.toLocaleLowerCase() !== "/set-password" && window.location.pathname.toLocaleLowerCase() !== "/forgot-password" && window.location.pathname.toLocaleLowerCase() !== "/") ?
                            <>
                                <Route name="Layout" path="/" element={<Layout key={'Layout'} componentRoutes={props.componentRoutes} />} >
                                    {
                                        (props.authDetails?.roleId && props.authDetails.roleId > 0) ?
                                            <>
                                                {props.componentRoutes && props?.componentRoutes.map((route, idx) => {
                                                    return (
                                                        <React.Fragment key={idx}>
                                                            {
                                                                (route.roles.indexOf(props.authDetails.roleId) !== -1 ?
                                                                    <>
                                                                        {route.component && (
                                                                            <Route
                                                                                key={route.title}
                                                                                path={route.path}
                                                                                element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                                                        )}
                                                                    </>
                                                                    : <>
                                                                        {route.component && (
                                                                            <Route
                                                                                key={idx}
                                                                                path={'authentication/UnAuthorized'}
                                                                                element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                                                        )
                                                                        }
                                                                    </>)
                                                            }
                                                        </React.Fragment>)
                                                })}
                                            </>
                                            :
                                            <>
                                                <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                                            </>
                                    }
                                </Route>
                            </>
                            :
                            <>
                                <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                            </>
                    }

                    <Route exact name="Set password" path="/set-password" element={<SetPassword authDetails={props.authDetails} />} />
                    <Route exact name="Forgot password" path="/forgot-password" element={<ForgotPassword authDetails={props.authDetails} />} />
                    <Route exact name="Approve Form" path="/approve-form" element={<ApproveTimesheetExpense />} />
                    {/* {(props.authDetails?.roleId  && props.authDetails.roleId  > 0) ?
                        <Route path='*' exact={true} element={<UnAuthorized authDetails={props.authDetails} />} />
                        : null} */}
                </Routes>
            </React.Suspense>
        </Router>
    )
}

export default LayoutNavigation;